import React, { useState, useEffect, useCallback } from 'react';
import Icon from './AppIcon';

export const PWA_WALKTHROUGH_KEY = 'ks_pwa_walkthrough_seen';

/* ─── Inline SVG Illustrations ─── */

const IllustrationOffline = () => (
  <svg viewBox="0 0 280 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="280" height="160" fill="#F0FDF4" rx="14"/>
    {/* Cloud with slash */}
    <ellipse cx="140" cy="62" rx="58" ry="34" fill="#D1FAE5"/>
    <ellipse cx="116" cy="70" rx="38" ry="28" fill="#6EE7B7" opacity="0.7"/>
    <ellipse cx="164" cy="70" rx="38" ry="28" fill="#6EE7B7" opacity="0.7"/>
    <ellipse cx="140" cy="76" rx="58" ry="22" fill="#34D399" opacity="0.5"/>
    {/* Wifi off icon */}
    <circle cx="140" cy="68" r="26" fill="#059669" opacity="0.15"/>
    <path d="M124 60 Q140 50 156 60" stroke="#059669" strokeWidth="3" strokeLinecap="round" fill="none"/>
    <path d="M130 68 Q140 61 150 68" stroke="#059669" strokeWidth="3" strokeLinecap="round" fill="none"/>
    <circle cx="140" cy="76" r="4" fill="#059669"/>
    {/* Diagonal slash */}
    <line x1="120" y1="50" x2="160" y2="90" stroke="#EF4444" strokeWidth="3.5" strokeLinecap="round"/>
    {/* Phone showing cached content */}
    <rect x="50" y="85" width="70" height="58" fill="#1F2937" rx="10"/>
    <rect x="55" y="91" width="60" height="46" fill="#F9FAFB" rx="6"/>
    <rect x="59" y="95" width="52" height="12" fill="#D1FAE5" rx="3"/>
    <rect x="59" y="111" width="35" height="6" fill="#E5E7EB" rx="2"/>
    <rect x="59" y="120" width="45" height="6" fill="#E5E7EB" rx="2"/>
    <rect x="59" y="129" width="28" height="5" fill="#6EE7B7" rx="2"/>
    {/* Checkmark badge on phone */}
    <circle cx="115" cy="88" r="10" fill="#10B981"/>
    <path d="M109 88 L113 92 L121 84" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    {/* Property card floating */}
    <rect x="162" y="90" width="72" height="50" fill="white" rx="8" opacity="0.95" style={{filter:'drop-shadow(0 2px 8px rgba(0,0,0,0.10))'}}/>
    <rect x="162" y="90" width="72" height="22" fill="#A7F3D0" rx="8"/>
    <rect x="162" y="104" width="72" height="10" fill="#A7F3D0"/>
    <rect x="168" y="118" width="40" height="5" fill="#D1D5DB" rx="2"/>
    <rect x="168" y="127" width="28" height="5" fill="#34D399" rx="2"/>
    {/* Offline badge */}
    <rect x="168" y="88" width="36" height="12" fill="#F59E0B" rx="4" opacity="0.95"/>
    <text x="186" y="97" textAnchor="middle" fontSize="6.5" fill="white" fontWeight="bold">HORS-LIGNE</text>
  </svg>
);

const IllustrationPushAlerts = () => (
  <svg viewBox="0 0 280 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="280" height="160" fill="#FFF7ED" rx="14"/>
    {/* Phone */}
    <rect x="95" y="20" width="90" height="130" fill="#1F2937" rx="16"/>
    <rect x="101" y="27" width="78" height="116" fill="#F9FAFB" rx="10"/>
    <rect x="128" y="20" width="24" height="7" fill="#374151" rx="4"/>
    {/* Notification cards */}
    <rect x="105" y="35" width="70" height="28" fill="white" rx="6" style={{filter:'drop-shadow(0 1px 4px rgba(0,0,0,0.08))'}}>
    </rect>
    <circle cx="116" cy="49" r="7" fill="#F59E0B"/>
    <text x="116" y="52" textAnchor="middle" fontSize="8" fill="white">🏠</text>
    <rect x="128" y="40" width="40" height="4" fill="#1F2937" rx="2"/>
    <rect x="128" y="48" width="30" height="3" fill="#9CA3AF" rx="1.5"/>
    <rect x="128" y="54" width="22" height="3" fill="#F59E0B" rx="1.5"/>

    <rect x="105" y="68" width="70" height="28" fill="white" rx="6" style={{filter:'drop-shadow(0 1px 4px rgba(0,0,0,0.08))'}}>
    </rect>
    <circle cx="116" cy="82" r="7" fill="#EF4444"/>
    <text x="116" y="85" textAnchor="middle" fontSize="8" fill="white">📅</text>
    <rect x="128" y="73" width="38" height="4" fill="#1F2937" rx="2"/>
    <rect x="128" y="81" width="28" height="3" fill="#9CA3AF" rx="1.5"/>
    <rect x="128" y="87" width="20" height="3" fill="#EF4444" rx="1.5"/>

    <rect x="105" y="101" width="70" height="28" fill="white" rx="6" style={{filter:'drop-shadow(0 1px 4px rgba(0,0,0,0.08))'}}>
    </rect>
    <circle cx="116" cy="115" r="7" fill="#8B5CF6"/>
    <text x="116" y="118" textAnchor="middle" fontSize="8" fill="white">💬</text>
    <rect x="128" y="106" width="42" height="4" fill="#1F2937" rx="2"/>
    <rect x="128" y="114" width="32" height="3" fill="#9CA3AF" rx="1.5"/>
    <rect x="128" y="120" width="18" height="3" fill="#8B5CF6" rx="1.5"/>
    {/* Bell with rings */}
    <circle cx="220" cy="65" r="30" fill="#FEF3C7" opacity="0.8"/>
    <path d="M220 42 C210 42 202 50 202 60 L202 70 L195 78 L245 78 L238 70 L238 60 C238 50 230 42 220 42Z" fill="#F59E0B"/>
    <rect x="215" y="78" width="10" height="6" fill="#F59E0B" rx="3"/>
    {/* Rings */}
    <path d="M196 50 Q190 58 192 68" stroke="#FCD34D" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.7"/>
    <path d="M244 50 Q250 58 248 68" stroke="#FCD34D" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.7"/>
    <path d="M190 44 Q182 55 184 68" stroke="#FDE68A" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5"/>
    {/* Badge */}
    <circle cx="238" cy="42" r="10" fill="#EF4444"/>
    <text x="238" y="46" textAnchor="middle" fontSize="9" fill="white" fontWeight="bold">3</text>
  </svg>
);

const IllustrationSync = () => (
  <svg viewBox="0 0 280 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="280" height="160" fill="#FDF4FF" rx="14"/>
    {/* Left device - phone */}
    <rect x="30" y="35" width="70" height="110" fill="#1F2937" rx="12"/>
    <rect x="36" y="42" width="58" height="96" fill="#F9FAFB" rx="8"/>
    <rect x="58" y="35" width="14" height="5" fill="#374151" rx="3"/>
    {/* Phone content */}
    <rect x="40" y="48" width="50" height="16" fill="#E9D5FF" rx="4"/>
    <rect x="40" y="68" width="50" height="16" fill="#E9D5FF" rx="4"/>
    <rect x="40" y="88" width="50" height="16" fill="#E9D5FF" rx="4"/>
    <path d="M44 56 C44 54 46 52 48 52 C50 52 52 54 52 56 C52 58 48 62 48 62 C48 62 44 58 44 56Z" fill="#A855F7"/>
    <path d="M44 76 C44 74 46 72 48 72 C50 72 52 74 52 76 C52 78 48 82 48 82 C48 82 44 78 44 76Z" fill="#A855F7"/>
    <path d="M44 96 C44 94 46 92 48 92 C50 92 52 94 52 96 C52 98 48 102 48 102 C48 102 44 98 44 96Z" fill="#A855F7"/>
    {/* Sync arrows in middle */}
    <circle cx="140" cy="90" r="28" fill="#F3E8FF" opacity="0.8"/>
    <path d="M126 82 Q140 70 154 82" stroke="#A855F7" strokeWidth="3" strokeLinecap="round" fill="none"/>
    <polygon points="154,82 158,76 162,84" fill="#A855F7"/>
    <path d="M154 98 Q140 110 126 98" stroke="#7C3AED" strokeWidth="3" strokeLinecap="round" fill="none"/>
    <polygon points="126,98 122,104 118,96" fill="#7C3AED"/>
    {/* Spinning indicator */}
    <circle cx="140" cy="90" r="10" fill="none" stroke="#C4B5FD" strokeWidth="2" strokeDasharray="8 4"/>
    <circle cx="140" cy="90" r="5" fill="#A855F7"/>
    {/* Right device - desktop */}
    <rect x="180" y="45" width="80" height="60" fill="#1F2937" rx="8"/>
    <rect x="185" y="50" width="70" height="50" fill="#F9FAFB" rx="5"/>
    <rect x="210" y="105" width="20" height="8" fill="#374151" rx="2"/>
    <rect x="195" y="113" width="50" height="5" fill="#4B5563" rx="2"/>
    {/* Desktop content */}
    <rect x="189" y="54" width="62" height="10" fill="#E9D5FF" rx="3"/>
    <rect x="189" y="68" width="62" height="10" fill="#E9D5FF" rx="3"/>
    <rect x="189" y="82" width="40" height="10" fill="#E9D5FF" rx="3"/>
    <path d="M193 59 C193 57 195 55 197 55 C199 55 201 57 201 59 C201 61 197 65 197 65 C197 65 193 61 193 59Z" fill="#A855F7"/>
    <path d="M193 73 C193 71 195 69 197 69 C199 69 201 71 201 73 C201 75 197 79 197 79 C197 79 193 75 193 73Z" fill="#A855F7"/>
    {/* Cloud sync badge */}
    <circle cx="248" cy="48" r="14" fill="#10B981"/>
    <path d="M242 50 L246 54 L254 46" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

const IllustrationShortcuts = () => (
  <svg viewBox="0 0 280 160" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="280" height="160" fill="#F0F9FF" rx="14"/>
    {/* Phone home screen */}
    <rect x="80" y="15" width="120" height="135" fill="#1F2937" rx="18"/>
    <rect x="87" y="22" width="106" height="121" fill="#1E3A5F" rx="12"/>
    <rect x="107" y="15" width="26" height="7" fill="#374151" rx="4"/>
    {/* Status bar */}
    <rect x="87" y="22" width="106" height="14" fill="#1E3A5F" rx="12"/>
    <text x="140" y="32" textAnchor="middle" fontSize="7" fill="#93C5FD">9:41</text>
    {/* App grid */}
    {/* Row 1 */}
    <rect x="95" y="42" width="26" height="26" fill="#F59E0B" rx="8"/>
    <text x="108" y="58" textAnchor="middle" fontSize="13">🏠</text>
    <rect x="127" y="42" width="26" height="26" fill="#EF4444" rx="8"/>
    <text x="140" y="58" textAnchor="middle" fontSize="13">❤️</text>
    <rect x="159" y="42" width="26" height="26" fill="#8B5CF6" rx="8"/>
    <text x="172" y="58" textAnchor="middle" fontSize="13">🔔</text>
    {/* Row 2 */}
    <rect x="95" y="74" width="26" height="26" fill="#10B981" rx="8"/>
    <text x="108" y="90" textAnchor="middle" fontSize="13">🗺️</text>
    <rect x="127" y="74" width="26" height="26" fill="#3B82F6" rx="8"/>
    <text x="140" y="90" textAnchor="middle" fontSize="13">📅</text>
    <rect x="159" y="74" width="26" height="26" fill="#F97316" rx="8"/>
    <text x="172" y="90" textAnchor="middle" fontSize="13">💬</text>
    {/* Kapital States app highlighted */}
    <rect x="95" y="106" width="26" height="26" fill="#0a0a0a" rx="8" style={{filter:'drop-shadow(0 0 6px rgba(201,168,76,0.7))'}}>
    </rect>
    <image href="/assets/images/Logo_d_immeuble_moderne_en_or-1758887759495.png" x="97" y="108" width="22" height="22"/>
    <rect x="127" y="106" width="26" height="26" fill="#6B7280" rx="8" opacity="0.4"/>
    <rect x="159" y="106" width="26" height="26" fill="#6B7280" rx="8" opacity="0.4"/>
    {/* App label */}
    <text x="108" y="140" textAnchor="middle" fontSize="6" fill="#93C5FD">Kapital</text>
    {/* Shortcut context menu */}
    <rect x="170" y="95" width="80" height="58" fill="white" rx="10" style={{filter:'drop-shadow(0 4px 16px rgba(0,0,0,0.18))'}}>
    </rect>
    <rect x="174" y="100" width="72" height="12" fill="#F9FAFB" rx="4"/>
    <text x="210" y="109" textAnchor="middle" fontSize="6.5" fill="#374151">Mon Espace</text>
    <rect x="174" y="115" width="72" height="12" fill="#F9FAFB" rx="4"/>
    <text x="210" y="124" textAnchor="middle" fontSize="6.5" fill="#374151">Rechercher</text>
    <rect x="174" y="130" width="72" height="12" fill="#F9FAFB" rx="4"/>
    <text x="210" y="139" textAnchor="middle" fontSize="6.5" fill="#374151">Mes Alertes</text>
    {/* Arrow pointing to app */}
    <path d="M170 115 L162 118" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" markerEnd="url(#arr)"/>
    {/* Gold glow ring around app */}
    <circle cx="108" cy="119" r="17" fill="none" stroke="#C9A84C" strokeWidth="2" strokeDasharray="4 2" opacity="0.8"/>
  </svg>
);

/* ─── Step data ─── */
const STEPS = [
  {
    id: 'offline',
    icon: 'WifiOff',
    iconBg: 'bg-emerald-100 dark:bg-emerald-900/40',
    iconColor: 'text-emerald-600 dark:text-emerald-400',
    accentFrom: 'from-emerald-500',
    accentTo: 'to-teal-500',
    badgeBg: 'bg-emerald-50 dark:bg-emerald-900/30',
    badgeText: 'text-emerald-700 dark:text-emerald-300',
    badgeBorder: 'border-emerald-200 dark:border-emerald-700',
    badge: 'Accès hors-ligne',
    title: 'Consultez vos biens sans connexion',
    description:
      'Vos propriétés sauvegardées et vos rendez-vous sont mis en cache localement. Parcourez-les même sans réseau — les données se synchronisent dès que vous êtes reconnecté.',
    Illustration: IllustrationOffline,
  },
  {
    id: 'push',
    icon: 'Bell',
    iconBg: 'bg-amber-100 dark:bg-amber-900/40',
    iconColor: 'text-amber-600 dark:text-amber-400',
    accentFrom: 'from-amber-500',
    accentTo: 'to-orange-500',
    badgeBg: 'bg-amber-50 dark:bg-amber-900/30',
    badgeText: 'text-amber-700 dark:text-amber-300',
    badgeBorder: 'border-amber-200 dark:border-amber-700',
    badge: 'Alertes push',
    title: 'Ne manquez aucune opportunité',
    description:
      'Recevez des notifications instantanées pour les baisses de prix, les nouveaux biens correspondant à vos critères, les rappels de rendez-vous et les messages de vos conseillers.',
    Illustration: IllustrationPushAlerts,
  },
  {
    id: 'sync',
    icon: 'RefreshCw',
    iconBg: 'bg-purple-100 dark:bg-purple-900/40',
    iconColor: 'text-purple-600 dark:text-purple-400',
    accentFrom: 'from-purple-500',
    accentTo: 'to-violet-500',
    badgeBg: 'bg-purple-50 dark:bg-purple-900/30',
    badgeText: 'text-purple-700 dark:text-purple-300',
    badgeBorder: 'border-purple-200 dark:border-purple-700',
    badge: 'Synchronisation',
    title: 'Vos favoris toujours à jour',
    description:
      'Votre liste de souhaits, vos alertes et vos rendez-vous se synchronisent automatiquement entre tous vos appareils. Ajoutez un bien sur mobile, retrouvez-le sur desktop.',
    Illustration: IllustrationSync,
  },
  {
    id: 'shortcuts',
    icon: 'Zap',
    iconBg: 'bg-sky-100 dark:bg-sky-900/40',
    iconColor: 'text-sky-600 dark:text-sky-400',
    accentFrom: 'from-sky-500',
    accentTo: 'to-blue-500',
    badgeBg: 'bg-sky-50 dark:bg-sky-900/30',
    badgeText: 'text-sky-700 dark:text-sky-300',
    badgeBorder: 'border-sky-200 dark:border-sky-700',
    badge: 'Raccourcis rapides',
    title: 'Accès direct depuis votre écran d\'accueil',
    description:
      'Appuyez longuement sur l\'icône Kapital States pour accéder directement à Mon Espace, la recherche de propriétés ou vos alertes — sans ouvrir l\'app.',
    Illustration: IllustrationShortcuts,
  },
];

/* ─── Main Component ─── */
const PWAWalkthrough = ({ onDismiss }) => {
  const [step, setStep] = useState(0);
  const [exiting, setExiting] = useState(false);
  const [animDir, setAnimDir] = useState('forward'); // 'forward' | 'back'

  const current = STEPS?.[step];
  const isLast = step === STEPS?.length - 1;

  const handleClose = useCallback(() => {
    localStorage.setItem(PWA_WALKTHROUGH_KEY, '1');
    setExiting(true);
    setTimeout(() => onDismiss?.(), 280);
  }, [onDismiss]);

  const handleNext = useCallback(() => {
    if (isLast) { handleClose(); return; }
    setAnimDir('forward');
    setStep(s => s + 1);
  }, [isLast, handleClose]);

  const handleBack = useCallback(() => {
    if (step === 0) return;
    setAnimDir('back');
    setStep(s => s - 1);
  }, [step]);

  const handleSkip = useCallback(() => {
    handleClose();
  }, [handleClose]);

  // Close on Escape
  useEffect(() => {
    const handler = (e) => { if (e?.key === 'Escape') handleClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [handleClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Guide de démarrage PWA"
      className={`fixed inset-0 z-[10000] flex items-end sm:items-center justify-center p-4 transition-all duration-300 ${
        exiting ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={handleClose}
        aria-hidden="true"
      />
      {/* Card */}
      <div
        className={`relative w-full max-w-md bg-white dark:bg-zinc-900 rounded-2xl shadow-2xl shadow-black/30 overflow-hidden transition-all duration-300 ${
          exiting ? 'translate-y-8 opacity-0 scale-95' : 'translate-y-0 opacity-100 scale-100'
        }`}
      >
        {/* Gold accent bar */}
        <div className="h-1 w-full bg-gradient-to-r from-brand-gold via-yellow-400 to-brand-gold" />

        {/* Progress bar */}
        <div className="h-0.5 w-full bg-zinc-100 dark:bg-zinc-800">
          <div
            className={`h-full bg-gradient-to-r ${current?.accentFrom} ${current?.accentTo} transition-all duration-500 ease-out`}
            style={{ width: `${((step + 1) / STEPS?.length) * 100}%` }}
          />
        </div>

        {/* Header */}
        <div className="flex items-center justify-between px-5 pt-4 pb-2">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg overflow-hidden bg-black flex items-center justify-center">
              <img
                src="/assets/images/Logo_d_immeuble_moderne_en_or-1758887759495.png"
                alt="Kapital States"
                className="w-5 h-5 object-contain"
              />
            </div>
            <span className="text-xs font-semibold text-zinc-500 dark:text-zinc-400 tracking-wide uppercase">
              Guide de démarrage
            </span>
          </div>
          <button
            onClick={handleClose}
            aria-label="Fermer le guide"
            className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors"
          >
            <Icon name="X" size={14} className="text-zinc-400" />
          </button>
        </div>

        {/* Illustration */}
        <div className="px-5 pt-1">
          <div className="w-full h-36 rounded-xl overflow-hidden">
            <current.Illustration />
          </div>
        </div>

        {/* Content */}
        <div className="px-5 pt-4 pb-2">
          {/* Badge */}
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${current?.badgeBg} ${current?.badgeText} ${current?.badgeBorder} mb-3`}
          >
            <div className={`w-5 h-5 rounded-md flex items-center justify-center ${current?.iconBg}`}>
              <Icon name={current?.icon} size={11} className={current?.iconColor} />
            </div>
            {current?.badge}
          </span>

          <h2 className="text-base font-bold text-zinc-900 dark:text-zinc-50 leading-snug mb-2">
            {current?.title}
          </h2>
          <p className="text-sm text-zinc-500 dark:text-zinc-400 leading-relaxed">
            {current?.description}
          </p>
        </div>

        {/* Step dots */}
        <div className="flex items-center justify-center gap-1.5 pt-3 pb-1">
          {STEPS?.map((s, i) => (
            <button
              key={s?.id}
              onClick={() => { setAnimDir(i > step ? 'forward' : 'back'); setStep(i); }}
              aria-label={`Étape ${i + 1}`}
              className={`rounded-full transition-all duration-300 ${
                i === step
                  ? `w-5 h-2 bg-gradient-to-r ${current?.accentFrom} ${current?.accentTo}`
                  : 'w-2 h-2 bg-zinc-200 dark:bg-zinc-700 hover:bg-zinc-300 dark:hover:bg-zinc-600'
              }`}
            />
          ))}
        </div>

        {/* Actions */}
        <div className="flex items-center justify-between px-5 pt-3 pb-5 gap-3">
          {step > 0 ? (
            <button
              onClick={handleBack}
              className="flex items-center gap-1.5 text-sm font-medium text-zinc-500 dark:text-zinc-400 hover:text-zinc-700 dark:hover:text-zinc-200 transition-colors"
            >
              <Icon name="ChevronLeft" size={15} />
              Retour
            </button>
          ) : (
            <button
              onClick={handleSkip}
              className="text-sm font-medium text-zinc-400 dark:text-zinc-500 hover:text-zinc-600 dark:hover:text-zinc-300 transition-colors"
            >
              Passer
            </button>
          )}

          <button
            onClick={handleNext}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold text-white bg-gradient-to-r ${current?.accentFrom} ${current?.accentTo} hover:opacity-90 active:scale-95 transition-all duration-150 shadow-md`}
          >
            {isLast ? (
              <>
                <Icon name="CheckCircle" size={15} />
                Commencer
              </>
            ) : (
              <>
                Suivant
                <Icon name="ChevronRight" size={15} />
              </>
            )}
          </button>
        </div>

        {/* Step counter */}
        <div className="absolute top-4 right-12">
          <span className="text-xs text-zinc-400 dark:text-zinc-500 font-medium">
            {step + 1} / {STEPS?.length}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PWAWalkthrough;
